// ----- Phase 5.X-publish-governance — Shared modal shell -----
//
// All 5 governance modals share the same overlay/dialog look-and-feel
// the existing CompileSubmissionPanel uses (overlay backdrop, centered
// rounded card). The styles + button styles live in
// `./modalShellStyles.ts` (split out so React Fast Refresh's
// "only-export-components" rule is happy with this .tsx file).
//
// Not a generic Dialog/ConfirmModal extraction — that exists already
// (`web/src/components/shared/ConfirmModal.tsx`) but its API is biased
// to single-action confirms. Governance modals have richer bodies
// (checklist items, radio groups, error states) so the shell is
// purpose-built for this phase.

import type { ReactElement, ReactNode } from 'react';
import { MovableDialog } from '@/components/shared/MovableDialog';

export interface ModalShellProps {
  readonly testId: string;
  readonly title: string;
  /** phase-movable-dialogs — Escape close; omitted = non-dismissable modal. */
  readonly onClose?: (() => void) | undefined;
  readonly children: ReactNode;
}

/**
 * Overlay + card, movable. phase-movable-dialogs: the shell now renders
 * through the ONE shared MovableDialog (title-bar drag, clamped on-screen,
 * per-dialog remembered position, Escape when onClose is provided). All five
 * governance modals inherit it from this single site.
 */
export function ModalShell({ testId, title, onClose, children }: ModalShellProps): ReactElement {
  return (
    <MovableDialog
      persistKey={`governance.${testId}`}
      title={title}
      onClose={onClose}
      testId={testId}
      width={560}
    >
      {children}
    </MovableDialog>
  );
}
